import * as React from 'react';

import Page from './Page';
import {RouteComponentProps} from 'react-router';
import VectorsInACartesianPlaneComponent from './components/webGL/VectorsInACartesianPlaneComponent';
import PolygonsComponent from './components/webGL/PolygonsComponent';
import SketchComponent from './components/webGL/SketchComponent';

interface State {
	username: string;
	emailAddress: string;
	password: string;
}

export default class WebGLPage extends Page<RouteComponentProps<void>, State> {

	public constructor (props: RouteComponentProps<void>) {
		super(props);

		this.state = {
			username: '',
			emailAddress: '',
			password: ''
		};
	}

	protected isLoading (): any {
		return false;
	}

	protected renderTitle (): string {
		return 'Web GL - Brain Brooder';
	}

	protected renderDescription (): string {
		return '';
	}

	protected renderContent () {
		return (
			<div>
				<h2>Colored vectors in a cartesian plane</h2>
				<VectorsInACartesianPlaneComponent size={720} />

				<h2 style={{marginTop: '200px'}}>Animated polygons and compositions</h2>
				<PolygonsComponent size={720} />

				<h2 style={{marginTop: '200px'}}>Sketch</h2>
				<SketchComponent size={600} />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/WebGLPage.tsx